/* the size for summaryHeading (h2) is h4 from styleguide.css */

.chart {
  height: 180px;
  width: 350px;
  font-size: 0.7em;
  margin: 1em 0 1em -2.5em;
}

.figcaption {
  font-size: 1rem;
}

@media (max-width: 48em) {
  .container {
    display: block;
  }

  .right {
    padding-left: 0;
  }

  .chart {
    width: 100%;
  }
}
